module.exports = __webpack_public_path__ + "static/media/013-sun-8.c88df3f7.svg";